const storage = {
  getItem<T = unknown>(key: string): T | null {
    // Check if we're in the browser
    if (typeof window === "undefined") {
      return null;
    }

    try {
      const data = localStorage.getItem(key);
      if (!data) return null;

      return JSON.parse(data);
    } catch {
      // If JSON parsing fails, return the raw string
      return localStorage.getItem(key) as T;
    }
  },

  setItem(key: string, value: unknown): void {
    if (typeof window === "undefined") {
      console.warn("Storage not available in SSR environment");
      return;
    }

    try {
      localStorage.setItem(key, JSON.stringify(value));
    } catch (error) {
      console.error(`Error setting item "${key}":`, error);
    }
  },

  removeItem(key: string): void {
    if (typeof window === "undefined") {
      return;
    }

    try {
      localStorage.removeItem(key);
    } catch (error) {
      console.error(`Error removing item "${key}":`, error);
    }
  },

  clear(): void {
    if (typeof window === "undefined") {
      return;
    }

    try {
      localStorage.clear();
    } catch (error) {
      console.error("Error clearing storage:", error);
    }
  },

  hasItem(key: string): boolean {
    if (typeof window === "undefined") {
      return false;
    }

    return localStorage.getItem(key) !== null;
  },
};

export default storage;
